import { NumberColumn, StringColumn, DateTimeColumn } from '../../layout/column.model';
import { HistoryFields } from '../history.fields';
import { BaseFields } from '../base.fields';

export class ApiKeyUserFields extends BaseFields {
  get id(): NumberColumn {
    return new NumberColumn(this.base + 'id', $localize`Identifier`);
  }

  get login(): StringColumn {
    return new StringColumn(this.base + 'login', $localize`User`);
  }

  get name(): StringColumn {
    return new StringColumn(this.base + 'name', $localize`Username`);
  }
}

export class ApiKeyFields extends HistoryFields {
  get id(): NumberColumn {
    return new NumberColumn(this.base + 'id', $localize`Identifier`);
  }

  get key(): StringColumn {
    return new StringColumn(this.base + 'key', $localize`Key`);
  }

  get description(): StringColumn {
    return new StringColumn(this.base + 'description', $localize`Description`);
  }

  get expirationDate(): DateTimeColumn {
    return new DateTimeColumn(this.base + 'expirationDate', $localize`Expiration date`);
  }

  get user(): ApiKeyUserFields {
    return new ApiKeyUserFields(this.base + 'user.');
  }
}
